var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { GridItemEvent } from './GridItem';
export var GridEvent;
(function (GridEvent) {
    GridEvent["Clicked"] = "Clicked";
    GridEvent["ItemClicked"] = "ItemClicked";
    GridEvent["ItemHold"] = "ItemHold";
    GridEvent["Wheel"] = "Wheel";
})(GridEvent || (GridEvent = {}));
var Grid = (function (_super) {
    __extends(Grid, _super);
    function Grid(scene, config) {
        var _this = _super.call(this, scene, config.position.x, config.position.y) || this;
        _this.config = config;
        _this.itemsInRow = config.itemsInRow || 1;
        _this.horizontal = config.horizontal || false;
        _this.spacing = config.spacing || 0;
        _this.items = [];
        _this.scene.add.existing(_this);
        return _this;
    }
    Grid.prototype.clearAllItems = function () {
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            item.destroy();
        }
        this.items = [];
        this.setSize(0, 0);
    };
    Grid.prototype.removeItem = function (id) {
        var index = this.getItemIndexOfId(id);
        if (index === -1) {
            return false;
        }
        var itemToBeRemoved = this.items[index];
        this.switchItemsPositionsUpToIndex(index);
        this.items.splice(index, 1);
        itemToBeRemoved.destroy();
        this.updateSize();
        return true;
    };
    Grid.prototype.setItemAtGivenIndex = function (itemId, index) {
        var itemToPlace = this.getItemOfId(itemId);
        var itemOnDesiredPosition = this.items[index];
        if (!itemToPlace || !itemOnDesiredPosition) {
            return false;
        }
        return this.swapItemsPositions(itemToPlace, itemOnDesiredPosition);
    };
    Grid.prototype.swapItemsPositions = function (firstItem, secondItem) {
        if (firstItem === secondItem) {
            return true;
        }
        if (!firstItem || !secondItem) {
            return false;
        }
        var firstItemId = firstItem.getId();
        var secondItemId = secondItem.getId();
        if (!firstItemId || !secondItemId) {
            return false;
        }
        var firstItemPos = { x: firstItem.x, y: firstItem.y };
        firstItem.setPosition(secondItem.x, secondItem.y);
        secondItem.setPosition(firstItemPos.x, firstItemPos.y);
        var firstItemIndex = this.getItemIndexOfId(firstItemId);
        var secondItemIndex = this.getItemIndexOfId(secondItemId);
        var temp = firstItem;
        this.items[firstItemIndex] = secondItem;
        this.items[secondItemIndex] = temp;
        return true;
    };
    Grid.prototype.setItemsInRow = function (count) {
        this.itemsInRow = count;
    };
    Grid.prototype.addItem = function (item) {
        this.items.push(item);
        this.add(item);
        this.registerItemEvents(item);
        if (this.items.length === 1) {
            item.y = item.displayHeight * 0.5;
            item.x = item.displayWidth * 0.5;
            this.setSize(item.displayWidth, item.displayHeight);
            return;
        }
        if (this.horizontal) {
            var previousItem = this.items[this.items.length - 2];
            var itemIndex = this.items.length - 1;
            item.x = previousItem.x;
            if (itemIndex % this.itemsInRow === 0) {
                item.x += (previousItem.displayWidth + item.displayWidth) * 0.5 + this.spacing;
                item.y = this.items[itemIndex - (this.itemsInRow)].y;
            }
            else {
                item.y += previousItem.y + (previousItem.displayHeight + item.displayHeight) * 0.5 + this.spacing;
            }
        }
        else {
            var previousItem = this.items[this.items.length - 2];
            var itemIndex = this.items.length - 1;
            item.y = previousItem.y;
            if (itemIndex % this.itemsInRow === 0) {
                item.y += (previousItem.displayHeight + item.displayHeight) * 0.5 + this.spacing;
                item.x = this.items[itemIndex - (this.itemsInRow)].x;
            }
            else {
                item.x += previousItem.x + (previousItem.displayWidth + item.displayWidth) * 0.5 + this.spacing;
            }
        }
        this.updateSize();
    };
    Grid.prototype.getItemLocalPosition = function (index) {
        return { x: this.items[index].x, y: this.items[index].y };
    };
    Grid.prototype.getItemOfIndex = function (index) {
        return this.items[index];
    };
    Grid.prototype.getItemOfId = function (id) {
        return this.items[this.getItemIndexOfId(id)];
    };
    Grid.prototype.getItemIndexOfId = function (id) {
        return this.items.map(function (item) { return item.getId(); }).indexOf(id);
    };
    Grid.prototype.switchItemsPositionsUpToIndex = function (index) {
        for (var i = this.items.length - 1; i > index; i -= 1) {
            var prevItem = this.items[i - 1];
            this.items[i].setPosition(prevItem.x, prevItem.y);
        }
    };
    Grid.prototype.updateSize = function () {
        var edgeLeft = Phaser.Math.MAX_SAFE_INTEGER;
        var edgeRight = 0;
        var edgeTop = Phaser.Math.MAX_SAFE_INTEGER;
        var edgeBottom = 0;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            edgeLeft = Math.min(edgeLeft, item.x - item.displayWidth * 0.5);
            edgeRight = Math.max(edgeRight, item.x + item.displayWidth * 0.5);
            edgeTop = Math.min(edgeTop, item.y - item.displayHeight * 0.5);
            edgeBottom = Math.max(edgeBottom, item.y + item.displayHeight * 0.5);
        }
        this.setSize(Math.abs(edgeLeft - edgeRight), Math.abs(edgeTop - edgeBottom));
    };
    Grid.prototype.registerItemEvents = function (item) {
        var _this = this;
        item.on('dragend', function () {
            _this.emit('dragend');
        });
        item.on('dragY', function (dragY) {
            _this.emit('dragY', dragY);
        });
        item.on('dragX', function (dragX) {
            _this.emit('dragX', dragX);
        });
        item.on('wheel', function (pointer, dx, dy, dz) {
            _this.emit('wheel', pointer, dx, dy, dz);
            _this.emit(GridEvent.Wheel);
        });
        item.on(GridItemEvent.Clicked, function () {
            _this.emit(GridEvent.Clicked);
            _this.emit(GridEvent.ItemClicked, item);
        });
        item.on(GridItemEvent.Hold, function () {
            _this.emit(GridEvent.ItemHold, item);
        });
        item.on('pointerdown', function () {
            _this.emit('pointerdown');
        });
    };
    Grid.prototype.getItems = function () { return this.items; };
    Grid.prototype.getHeight = function () { return this.displayHeight; };
    return Grid;
}(Phaser.GameObjects.Container));
export { Grid };
